export const STORAGE_SEARCH_INDICATION = 'search_indication';
export const STORAGE_SEARCH_BIOMARKERS = 'search_biomarkers';
